<div class="slot-card-wrapper" [ngClass]="[bgCardClass, borderClass]" *ngIf="teamShiftDetail.teamShiftMembers.length">
  <div class="team-section">
    <div class="team-wrapper mt-10" *ngFor="let teamShiftMember of displayingTeamSlot">
      <div class="text team-name">{{teamShiftMember.firstName}} {{teamShiftMember.lastName}}</div>
      <!-- <div class="text red-text">PTO(All Day)</div> -->
      <div class="text" *ngFor="let shiftMemberSchedule of teamShiftMember.shiftMemberSchedules">
        <ng-container  *ngIf="shiftMemberSchedule?.leaveType">
        <span class="text red-text">{{shiftMemberSchedule?.leaveType}}
          ({{shiftMemberSchedule?.startTimeStr}} - {{shiftMemberSchedule?.endTimeStr}})</span>
        </ng-container>
      <ng-container  *ngIf="!shiftMemberSchedule?.leaveType"
      >
      <span [ngStyle]="{'background-color': shiftMemberSchedule.source === 'DUTY_ON_OFF' ? '#fcedce' : ''}">
        <span *ngIf="shiftMemberSchedule?.startTimeStr && shiftMemberSchedule?.endTimeStr">
          {{shiftMemberSchedule?.startTimeStr}} - {{shiftMemberSchedule?.endTimeStr}}
        </span>
      </span>
    
      </ng-container>
      </div>
      <div class="text" *ngIf="setNotAvailableFlag(teamShiftMember.shiftMemberSchedules)">
        <span>Shift Unavailable</span>
      </div>
    </div>
  </div>
  <div class="button-wrapper ui-g">
    <div class="left-wrapper ui-g-12 ui-md-12 ui-lg-6">
      <span class="text team-name blue-text" (click)="op.toggle($event)" *ngIf="teamSlots.length">{{teamSlots.length}}
        more</span>
    </div>
    <div class="right-wrapper ui-g-12 ui-md-12 ui-lg-6" [class.single-icon]="!isOpenShiftPermission || organizationLevelDispatch || !globalConfigOS  || providerLevelDutyFlag || teamLevelDutyFlag">
      <div class="icon" (click)="goToEdit(teamShiftDetail?.dateStr)" pTooltip="Edit team" tooltipPosition="top"
        tooltipStyleClass="custom-tooltip" *ngIf="date.setHours(0,0,0,0) >= minDate.setHours(0,0,0,0)"><img src="/assets/images/temp/edit-req.png" alt="edit icon" /></div>
      <div class="icon" (click)="openShift()" pTooltip="Publish open shift" tooltipPosition="top"
        tooltipStyleClass="custom-tooltip" *ngIf="globalConfigOS && isOpenShiftPermission && !organizationLevelDispatch  && !providerLevelDutyFlag && !teamLevelDutyFlag && (date.setHours(0,0,0,0) >= minDate.setHours(0,0,0,0))"><img src="/assets/images/temp/shift.svg" alt="shift icon" /></div>
    </div>
  </div>
</div>

<div class="unavailable-wrapper ui-g-12" [ngClass]="[borderClass]"  *ngIf="!teamShiftDetail.teamShiftMembers.length">
  <div class="icon"><img src="/assets/images/temp/calendar-cancel.svg" alt="no calendar invite" /></div>
  <h4 class="unavailable-heading" translate>label_unavailable</h4>
  <div class="button-wrapper ui-g-12 ui-md-12 ui-lg-12">
    <div class="left-wrapper ui-g-12 ui-md-12 ui-lg-6"></div>
    <div class="right-wrapper ui-g-12 ui-md-12 ui-lg-6" [class.single-icon]="!isOpenShiftPermission || organizationLevelDispatch || !globalConfigOS || providerLevelDutyFlag || teamLevelDutyFlag">
      <div class="icon" (click)="goToEdit(teamShiftDetail?.dateStr)" pTooltip="Edit team" tooltipPosition="top"
        tooltipStyleClass="custom-tooltip" *ngIf="date.setHours(0,0,0,0) >= minDate.setHours(0,0,0,0)"><img src="/assets/images/temp/edit-req.png" alt="edit icon" /></div>
      <div class="icon" (click)="openShift()" pTooltip="Publish open shift" tooltipPosition="top"
        tooltipStyleClass="custom-tooltip" *ngIf="isOpenShiftPermission && (date.setHours(0,0,0,0) >= minDate.setHours(0,0,0,0)) && globalConfigOS && !organizationLevelDispatch && !providerLevelDutyFlag && !teamLevelDutyFlag"><img src="/assets/images/temp/shift.svg" alt="shift icon" /></div>
    </div>
  </div>
</div>

<p-overlayPanel class="grid-overlay-panel" [showCloseIcon]="true" #op>
  <div class="header-wrapper">
    <span class="title">{{teamShiftDetail.dateStr | weekMonthDate}}</span>
    <!-- <span class="title cross-icon" (click)="op.toggle($event)">X</span> -->
  </div>
  <div class="body-wrapper" *ngFor="let teamSlot of teamShiftDetail.teamShiftMembers">
    <label class="text member-name">{{teamSlot?.firstName}} {{teamSlot?.lastName}}<span
        *ngIf="teamSlot?.shiftMemberSchedules.length">:</span></label>
    <div class="slot-wrapper">
      <ng-container *ngFor="let shiftMemberSchedule of teamSlot?.shiftMemberSchedules; let isLast = last;">
        <span class="text"
          *ngIf="shiftMemberSchedule?.startTimeStr && shiftMemberSchedule?.endTimeStr && !shiftMemberSchedule?.leaveType"
          [ngStyle]="{'background-color': shiftMemberSchedule.source === 'DUTY_ON_OFF' ? '#fcedce' : ''}">{{shiftMemberSchedule?.startTimeStr}}
          - {{shiftMemberSchedule?.endTimeStr}}<span
            *ngIf="(shiftMemberSchedule?.startTimeStr && shiftMemberSchedule?.endTimeStr) && !isLast">,</span> </span>

            <span class="text red-text"
            *ngIf="shiftMemberSchedule?.startTimeStr && shiftMemberSchedule?.endTimeStr && shiftMemberSchedule?.leaveType">{{shiftMemberSchedule?.leaveType}} ({{shiftMemberSchedule?.startTimeStr}}
            - {{shiftMemberSchedule?.endTimeStr}})<span
              *ngIf="(shiftMemberSchedule?.startTimeStr && shiftMemberSchedule?.endTimeStr) && !isLast">,</span> </span>

      </ng-container>
      <span class="text" *ngIf="setNotAvailableFlag(teamSlot?.shiftMemberSchedules)">Shift Unavailable</span>
    </div>
  </div>
</p-overlayPanel>
